<template>
  <div class="footer-btn x-flex-center" :style="{ padding: padding + ' 0' }">
    <el-button v-if="!hideClose" plain size="small" @click="close">{{ closeText }}</el-button>
    <div class="spacing" v-if="!hideClose && !hideConfirm" :style="{ width: spacing }"></div>
    <el-button v-if="!hideConfirm" size="small" type="primary" @click="confirm">{{
      confirmText
    }}</el-button>
    <slot></slot>
  </div>
</template>

<script>
import i18n from '@/i18n/index.js';
export default {
  name: 'MyFooterBtn',
  props: {
    hideClose: {
      type: Boolean,
      default: false
    },
    hideConfirm: {
      type: Boolean,
      default: false
    },
    spacing: {
      type: String,
      default: '120px'
    },
    padding: {
      type: String,
      default: '40px'
    },
    closeText: {
      type: String,
      default: () => i18n.t('HT.cancel')
    },
    confirmText: {
      type: String,
      default: () => i18n.t('HT.confirm')
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },

    confirm() {
      this.$emit('confirm');
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-btn {
  .el-button--small {
    padding: 7px 15px;
  }
}
</style>
